import { render, staticRenderFns } from "./SupportTicketMessageSection.vue?vue&type=template&id=ca99e708&scoped=true&"
import script from "./SupportTicketMessageSection.vue?vue&type=script&lang=js&"
export * from "./SupportTicketMessageSection.vue?vue&type=script&lang=js&"
import style0 from "./SupportTicketMessageSection.vue?vue&type=style&index=0&id=ca99e708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca99e708",
  null
  
)

export default component.exports